export default __webpack_public_path__ + "static/media/optique.32505480.jpg";